<template>
  <div class="calls-tab">
    <div class="calls-tab__table">
      <SubpanelTable
        :tableColumns="columns"
        :tableData="calls"
        :resetHeight="true"
        :emptyText="!calls?.length ? 'Звонков нет' : ''"
        :subpanelName="module"
        :resizable-table="true"
        min-column-width="150px"
        :class="['calls-tab__list']"
      />
    </div>
  </div>
</template>

<script>
import SubpanelTable from 'Elements/Table/SubpanelTable';
import { mixin, errorMsg } from '@/utils/mixins';

export default {
  mixins: [mixin, errorMsg],
  props: {
    metadata: [Array, Object]
  },
  data() {
    return {
      module: 'calls',
      calls: [],
      columns: {}
    };
  },
  created() {
    this.calls = this.metadata?.data?.List || this.metadata?.List;
    this.columns = this.metadata?.data?.title || this.metadata?.title;
  },
  components: {
    SubpanelTable
  }
};
</script>

<style lang="scss" scoped>
.calls-tab,
.calls-tab__table,
.table-panel,
.table-panel__buttons,
.table-panel__content {
  display: flex;
}

.calls-tab__table {
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  flex-direction: column;
}

.calls-tab {
  gap: 16px;

  &__table {
    gap: 20px;
    padding-left: 1px;
  }
}

.table-panel {
  justify-content: space-between;
  gap: 20px;

  &__list {
    height: calc(100vh - 229px);
  }
}

@media (max-width: 1199px) {
  .calls-tab__table:not(:last-of-type) {
    display: none;
  }
}

@media (min-width: 1199px) {
  .calls-tab__table:not(:last-of-type) {
    max-width: 298px;
  }
}

@media (min-width: 1513px) {
  .calls-tab__table:not(:last-of-type) {
    min-width: 504px;
  }
}

.table-panel__list {
  @media (min-width: 1512px) {
    & > *:first-child:not(:last-of-type) {
      max-width: 503px;
    }
  }

  @media (max-width: 1200px) {
    & > *:first-child:not(:last-of-type) {
      display: none;
    }
  }
}

.red-circle {
  position: absolute;
  top: 5px;
  right: 9px;
  width: 6px;
  height: 6px;
  z-index: 10;
  border-radius: 100%;
  margin: 0 !important;
  background: $red;
}

.hidden {
  display: none;
}
</style>
